export const countryInitialState = {
    country: null,
    isLoading: true,
};
